export function readStoredUser() {
  try {
    const raw = localStorage.getItem('currentUser') || localStorage.getItem('user') || '{}';
    return JSON.parse(raw);
  } catch {
    return {};
  }
}

function isTruthyFlag(value) {
  if (value === true) return true;
  if (value === 1) return true;
  const s = String(value ?? '').trim().toLowerCase();
  return s === '1' || s === 'true' || s === 'yes' || s === 'y';
}

function hasNamedRole(user = {}, expected = '') {
  const wanted = String(expected || '').trim().toLowerCase();
  if (!wanted) return false;
  const direct = [
    user?.role,
    user?.roleid,
    user?.userrole,
    user?.type,
    user?.usertype,
    user?.userType,
  ];
  if (direct.some((value) => String(value ?? '').trim().toLowerCase() === wanted)) return true;
  const roles = Array.isArray(user?.roles) ? user.roles : [];
  return roles.some((value) => String(value ?? '').trim().toLowerCase() === wanted);
}

export function isAdminUser(user = {}) {
  return (
    isTruthyFlag(user?.isadmin) ||
    isTruthyFlag(user?.isAdmin) ||
    hasNamedRole(user, 'admin') ||
    String(user?.roleid ?? '').trim().toLowerCase() === '1'
  );
}

export function isClientUser(user = {}) {
  return (
    isTruthyFlag(user?.isclient) ||
    isTruthyFlag(user?.isClient) ||
    isTruthyFlag(user?.client) ||
    isTruthyFlag(user?.clientuser) ||
    hasNamedRole(user, 'client')
  );
}
